var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCryptoWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87.679,
    height: 67.123,
    viewBox: "0 0 87.679 67.123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-digital-1975122",
    transform: "translate(-70.004 -65.628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M154.935,88.971V71.108a5.479,5.479,0,0,0-5.48-5.479h-13.7v13.7h4.349a4.11,4.11,0,1,1,0,2.739h-5.719a1.37,1.37,0,0,1-1.37-1.37V65.628h-7.534v11.2a4.11,4.11,0,1,1-2.739,0v-11.2h-8.9v6.4a4.11,4.11,0,1,1-2.739,0v-6.4H75.483A5.479,5.479,0,0,0,70,71.108v8.219H97.641a4.11,4.11,0,1,1,0,2.739H70V92.34H109.97a4.11,4.11,0,1,1,0,2.739H70v9.589H109.97a4.11,4.11,0,1,1,0,2.739H70v8.9H101.75a4.11,4.11,0,1,1,0,2.739H70v8.219a5.479,5.479,0,0,0,5.479,5.479h57.535a1.336,1.336,0,0,1,0-.171v-14.9a1.37,1.37,0,0,1,1.37-1.37h5.719a4.11,4.11,0,1,1,0,2.739h-4.349v13.527a1.33,1.33,0,0,1,0,.171h13.7a5.479,5.479,0,0,0,5.48-5.479V109.408a5.979,5.979,0,0,0,2.74-5.308V94.278a5.979,5.979,0,0,0-2.74-5.308Zm-32.191,30.767a4.109,4.109,0,1,1,2.906-1.2A4.11,4.11,0,0,1,122.744,119.738ZM154.935,104.1c0,1.6-.747,3.309-2.836,3.309H134.586c-5.815,0-8.418-4.11-8.418-8.219s2.6-8.219,8.418-8.219H152.1c2.089,0,2.836,1.706,2.836,3.309Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    d: "M409.62,154.5a1.37,1.37,0,1,1-1.37-1.37,1.37,1.37,0,0,1,1.37,1.37",
    transform: "translate(-284.136 -73.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M335.24,123.87a1.37,1.37,0,1,1-1.37-1.37,1.37,1.37,0,0,1,1.37,1.37",
    transform: "translate(-221.401 -47.968)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M400.86,377.62a1.37,1.37,0,1,1-1.37-1.37,1.37,1.37,0,0,1,1.37,1.37",
    transform: "translate(-276.747 -261.992)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    "data-name": "Path 939",
    d: "M291.49,390.74a1.37,1.37,0,1,1-1.37-1.37,1.37,1.37,0,0,1,1.37,1.37",
    transform: "translate(-184.5 -273.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    d: "M536.49,154.5a1.37,1.37,0,1,1-1.37-1.37,1.37,1.37,0,0,1,1.37,1.37",
    transform: "translate(-391.144 -73.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M265.24,154.5a1.37,1.37,0,1,1-1.37-1.37,1.37,1.37,0,0,1,1.37,1.37",
    transform: "translate(-162.36 -73.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M343.99,237.62a1.37,1.37,0,1,1-1.37-1.37,1.37,1.37,0,0,1,1.37,1.37",
    transform: "translate(-228.781 -143.91)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M343.99,316.37a1.37,1.37,0,1,1-1.37-1.37,1.37,1.37,0,0,1,1.37,1.37",
    transform: "translate(-228.781 -210.331)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M536.49,390.74a1.37,1.37,0,1,1-1.37-1.37,1.37,1.37,0,0,1,1.37,1.37",
    transform: "translate(-391.144 -273.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M459.11,253.75a4.109,4.109,0,1,0,2.906,1.2A4.11,4.11,0,0,0,459.11,253.75Zm0,5.48a1.37,1.37,0,1,1,.969-.4A1.369,1.369,0,0,1,459.11,259.23Z",
    transform: "translate(-324.723 -158.67)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoWallet);
export default __webpack_public_path__ + "static/media/crypto-wallet.6f3835430722482ee1d089414dae09ee.svg";
export { ForwardRef as ReactComponent };